<div class="original__price">
  <!-- taro di usecase jgn pake pipe -->
    <span class="price">{{originalprice() ?? 0 | currency}}</span>
    <span class="discount">{{discount() ?? 0 | percentage}} </span>
</div>
